"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
exports.default = {
    type: "VerticalLayout",
    elements: [
        (0, common_1.makeAppointmentUiSchema)("futureAppointment", "Visit", {
            disablePast: true,
        }),
        (0, common_1.makeAppointmentConflictsUiSchema)("futureAppointment"),
        {
            type: "Control",
            label: "Notes",
            scope: "#/properties/notes",
        },
    ],
};
